// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import VinLookupController from "./vin_lookup_controller"
application.register("vin-lookup", VinLookupController)

import BatchSelectionController from "./batch_selection_controller"
application.register("batch-selection", BatchSelectionController)

import AddToSaleController from "./add_to_sale_controller"
application.register("add-to-sale", AddToSaleController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import VinSearchController from "./vin_search_controller"
application.register("vin-search", VinSearchController)

import TitleUploadController from "./title_upload_controller"
application.register("title-upload", TitleUploadController)

import TitleSplitController from "./title_split_controller"
application.register("title-split", TitleSplitController)

import PdfZoomController from "./pdf_zoom_controller"
application.register("pdf-zoom", PdfZoomController)

import PhotoSortController from "./photo_sort_controller"
application.register("photo-sort", PhotoSortController)

import NumericInputController from "./numeric_input_controller"
application.register("numeric-input", NumericInputController)

import AddressPrefillController from "./address_prefill_controller"
application.register("address-prefill", AddressPrefillController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import SaveStatusController from "./save_status_controller"
application.register("save-status", SaveStatusController)

import GridController from "./grid_controller"
application.register("grid", GridController)

import GridAutosaveController from "./grid_autosave_controller"
application.register("grid-autosave", GridAutosaveController)

import NestedForm from "@stimulus-components/rails-nested-form"
application.register("nested-form", NestedForm)

import ContactSelectController from "./contact_select_controller"
application.register("contact-select", ContactSelectController)

import NotificationReadController from "./notification_read_controller"
application.register("notification-read", NotificationReadController)

import SubmissionChecklistController from "./submission_checklist_controller"
application.register("submission-checklist", SubmissionChecklistController)
